{
  "accordion": {
    "panel": {
      "border": {
        "width": {
          "$type": "number",
          "$value": 1
        },
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    },
    "header": {
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "background": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.0000)"
      },
      "hover": {
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        },
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        }
      },
      "active": {
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        },
        "background": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.0000)"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{text.color}"
          }
        }
      },
      "font": {
        "weight": {
          "$type": "number",
          "$value": 600
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": 0
        },
        "width": {
          "$type": "number",
          "$value": 0
        },
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      },
      "toggle": {
        "icon": {
          "color": {
            "$type": "color",
            "$value": "{text.muted.color}"
          },
          "hover": {
            "color": {
              "$type": "color",
              "$value": "{text.color}"
            }
          },
          "active": {
            "color": {
              "$type": "color",
              "$value": "{text.color}"
            },
            "hover": {
              "color": {
                "$type": "color",
                "$value": "{text.color}"
              }
            }
          }
        }
      },
      "first": {
        "top": {
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{content.border.radius}"
            }
          }
        },
        "border": {
          "width": {
            "$type": "number",
            "$value": 0
          }
        }
      },
      "last": {
        "bottom": {
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{content.border.radius}"
            }
          }
        },
        "active": {
          "bottom": {
            "border": {
              "radius": {
                "$type": "number",
                "$value": 0
              }
            }
          }
        }
      }
    },
    "content": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "width": {
          "$type": "number",
          "$value": 0
        },
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{spacing.component.3}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "left": {
          "$type": "number",
          "$value": "{spacing.component.7}"
        }
      }
    }
  },
  "autocomplete": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "dropdown": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "hover": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      },
      "active": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{form.field.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      },
      "sm": {
        "width": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      },
      "lg": {
        "width": {
          "$type": "number",
          "$value": "{scale.3}"
        }
      }
    },
    "chip": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.sm}"
        }
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.select.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.select.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.select.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.select.border.radius}"
        }
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.padding.x}"
        }
      }
    },
    "option": {
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{list.option.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.focus.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{list.option.selected.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.selected.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.selected.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.selected.focus.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{list.option.border.radius}"
        }
      },
      "group": {
        "background": {
          "$type": "color",
          "$value": "{list.option.group.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.group.color}"
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": "{list.option.group.font.weight}"
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{list.option.group.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{list.option.group.padding.x}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.option.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.option.padding.x}"
        }
      }
    }
  },
  "avatar": {
    "width": {
      "$type": "number",
      "$value": "{scale.2}"
    },
    "height": {
      "$type": "number",
      "$value": "{scale.2}"
    },
    "background": {
      "$type": "color",
      "$value": "{content.border.color}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "font": {
      "size": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "group": {
      "offset": {
        "$type": "number",
        "$value": "{scale.neg-0-75}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.background}"
        }
      }
    },
    "lg": {
      "width": {
        "$type": "number",
        "$value": "{scale.3}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.3}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      },
      "group": {
        "offset": {
          "$type": "number",
          "$value": "{scale.neg-1}"
        }
      }
    },
    "xl": {
      "width": {
        "$type": "number",
        "$value": "{scale.4}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.4}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      },
      "group": {
        "offset": {
          "$type": "number",
          "$value": "{scale.neg-1-5}"
        }
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    }
  },
  "badge": {
    "height": {
      "$type": "number",
      "$value": "{scale.1-5}"
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": 0
      },
      "x": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{border.radius.md}"
      }
    },
    "font": {
      "size": {
        "$type": "number",
        "$value": "{scale.0-75}"
      },
      "weight": {
        "$type": "number",
        "$value": 700
      }
    },
    "min": {
      "width": {
        "$type": "number",
        "$value": "{scale.1-5}"
      }
    },
    "dot": {
      "size": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "sm": {
      "height": {
        "$type": "number",
        "$value": "{scale.1-25}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-625}"
        }
      },
      "min": {
        "width": {
          "$type": "number",
          "$value": "{scale.1-25}"
        }
      }
    },
    "lg": {
      "height": {
        "$type": "number",
        "$value": "{scale.1-75}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        }
      },
      "min": {
        "width": {
          "$type": "number",
          "$value": "{scale.1-75}"
        }
      }
    },
    "xl": {
      "height": {
        "$type": "number",
        "$value": "{scale.2}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "min": {
        "width": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    }
  },
  "blockui": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    }
  },
  "breadcrumb": {
    "padding": {
      "$type": "number",
      "$value": "{scale.1}"
    },
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{text.muted.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{navigation.item.gap}"
      },
      "hover": {
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      }
    },
    "separator": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.icon.color}"
      }
    }
  },
  "button": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "rounded": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "icon": {
      "only": {
        "width": {
          "$type": "number",
          "$value": "{scale.2-5}"
        }
      }
    },
    "sm": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      },
      "icon": {
        "only": {
          "width": {
            "$type": "number",
            "$value": "{scale.2}"
          }
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      }
    },
    "lg": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": 10
        },
        "y": {
          "$type": "number",
          "$value": 14
        }
      },
      "icon": {
        "only": {
          "width": {
            "$type": "number",
            "$value": "{scale.3}"
          }
        }
      }
    },
    "label": {
      "font": {
        "weight": {
          "$type": "number",
          "$value": 500
        }
      }
    },
    "focus": {
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        }
      }
    }
  },
  "card": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{border.radius.xl}"
      }
    },
    "body": {
      "padding": {
        "$type": "number",
        "$value": "{scale.1-25}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "caption": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "title": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-25}"
        },
        "weight": {
          "$type": "number",
          "$value": 500
        }
      }
    },
    "subtitle": {
      "color": {
        "$type": "color",
        "$value": "{text.muted.color}"
      }
    }
  },
  "carousel": {
    "indicator": {
      "width": {
        "$type": "number",
        "$value": "{scale.2}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "list": {
        "padding": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    },
    "content": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-25}"
      }
    }
  },
  "cascadeselect": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "dropdown": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.select.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.select.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.select.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.select.border.radius}"
        }
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.padding.x}"
        }
      },
      "mobile": {
        "indent": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "option": {
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{list.option.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.focus.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{list.option.selected.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.selected.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.selected.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.selected.focus.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{list.option.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{list.option.icon.color}"
        },
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{list.option.icon.focus.color}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.option.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.option.padding.x}"
        }
      }
    },
    "sm": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      }
    },
    "lg": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.lg.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.lg.padding.y}"
        }
      }
    },
    "clear": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{form.field.icon.color}"
        }
      }
    }
  },
  "checkbox": {
    "width": {
      "$type": "number",
      "$value": "{scale.1-25}"
    },
    "height": {
      "$type": "number",
      "$value": "{scale.1-25}"
    },
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{border.radius.sm}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      }
    },
    "checked": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{primary.hover.color}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.hover.color}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "focus": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        }
      },
      "disabled": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.0-875}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.color}"
      },
      "checked": {
        "color": {
          "$type": "color",
          "$value": "{primary.contrast.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{primary.contrast.color}"
          }
        }
      },
      "disabled": {
        "color": {
          "$type": "color",
          "$value": "{form.field.disabled.color}"
        }
      },
      "sm": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      },
      "lg": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "sm": {
      "width": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "lg": {
      "width": {
        "$type": "number",
        "$value": "{scale.1-5}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.1-5}"
      }
    }
  },
  "chip": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "remove": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": 16
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{scale.0-75}"
      },
      "y": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "image": {
      "width": {
        "$type": "number",
        "$value": "{scale.2}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.2}"
      }
    }
  },
  "colorpicker": {
    "panel": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{overlay.popover.border.radius}"
        }
      }
    },
    "preview": {
      "width": {
        "$type": "number",
        "$value": "{scale.1-5}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.1-5}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{form.field.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      }
    }
  },
  "confirmdialog": {
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.2}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.modal.color}"
      }
    },
    "content": {
      "gap": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    }
  },
  "confirmpopup": {
    "background": {
      "$type": "color",
      "$value": "{overlay.popover.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{overlay.popover.color}"
    },
    "gutter": {
      "$type": "number",
      "$value": 10
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{overlay.popover.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{overlay.popover.border.radius}"
      }
    },
    "arrow": {
      "offset": {
        "$type": "number",
        "$value": "{scale.1-25}"
      }
    },
    "content": {
      "padding": {
        "$type": "number",
        "$value": "{overlay.popover.padding}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.1-5}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.popover.color}"
      }
    },
    "footer": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{overlay.popover.padding}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{overlay.popover.padding}"
        },
        "left": {
          "$type": "number",
          "$value": "{overlay.popover.padding}"
        }
      }
    }
  },
  "contextmenu": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{navigation.list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.list.padding.x}"
        }
      }
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{navigation.item.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.focus.color}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.active.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.active.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{navigation.item.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.active.color}"
          }
        }
      }
    },
    "submenu": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{navigation.submenu.icon.size}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.active.color}"
          }
        }
      },
      "mobile": {
        "indent": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "separator": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    }
  },
  "datepicker": {
    "select": {
      "year": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-25}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-5}"
          }
        },
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{content.hover.color}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{content.border.radius}"
          }
        }
      },
      "month": {
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{content.hover.color}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{content.border.radius}"
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-25}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-5}"
          }
        }
      }
    },
    "year": {
      "view": {
        "margin": {
          "top": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "right": {
            "$type": "number",
            "$value": 0
          },
          "bottom": {
            "$type": "number",
            "$value": 0
          },
          "left": {
            "$type": "number",
            "$value": 0
          }
        }
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.0-375}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    },
    "dropdown": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "hover": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      },
      "active": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{form.field.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      },
      "sm": {
        "width": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      },
      "lg": {
        "width": {
          "$type": "number",
          "$value": "{scale.3}"
        }
      }
    },
    "panel": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "$type": "number",
        "$value": "{overlay.popover.padding}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{radius.medium}"
        }
      }
    },
    "header": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": 0
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "left": {
          "$type": "number",
          "$value": 0
        }
      }
    },
    "title": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "font": {
        "weight": {
          "$type": "number",
          "$value": 500
        }
      }
    },
    "input": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{form.field.icon.color}"
        }
      }
    },
    "group": {
      "gap": {
        "$type": "number",
        "$value": "{overlay.popover.padding}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    },
    "week": {
      "day": {
        "padding": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": 500
          }
        }
      }
    },
    "date": {
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "width": {
        "$type": "number",
        "$value": "{scale.2}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.2}"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.hover.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{primary.color}"
        },
        "color": {
          "$type": "color",
          "$value": "{primary.contrast.color}"
        }
      },
      "range": {
        "selected": {
          "background": {
            "$type": "color",
            "$value": "{highlight.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{highlight.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      }
    },
    "buttonbar": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "right": {
          "$type": "number",
          "$value": 0
        },
        "bottom": {
          "$type": "number",
          "$value": 0
        },
        "left": {
          "$type": "number",
          "$value": 0
        }
      }
    },
    "time": {
      "picker": {
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          }
        },
        "button": {
          "gap": {
            "$type": "number",
            "$value": "{scale.0-25}"
          }
        },
        "padding": {
          "top": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "right": {
            "$type": "number",
            "$value": 0
          },
          "bottom": {
            "$type": "number",
            "$value": 0
          },
          "left": {
            "$type": "number",
            "$value": 0
          }
        }
      }
    },
    "month": {
      "padding": {
        "$type": "number",
        "$value": "{scale.0-375}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "view": {
        "margin": {
          "top": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "right": {
            "$type": "number",
            "$value": 0
          },
          "bottom": {
            "$type": "number",
            "$value": 0
          },
          "left": {
            "$type": "number",
            "$value": 0
          }
        }
      }
    },
    "day": {
      "view": {
        "margin": {
          "top": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "right": {
            "$type": "number",
            "$value": 0
          },
          "bottom": {
            "$type": "number",
            "$value": 0
          },
          "left": {
            "$type": "number",
            "$value": 0
          }
        }
      }
    }
  },
  "datatable": {
    "header": {
      "background": {
        "$type": "color",
        "$value": "{colours.basic.background-subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "lg": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.1}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1-25}"
          }
        }
      },
      "sm": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-375}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-5}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "cell": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        },
        "background": {
          "$type": "color",
          "$value": "{colours.basic.background-subtle}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "lg": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.1}"
            },
            "x": {
              "$type": "number",
              "$value": "{scale.1-25}"
            }
          }
        },
        "sm": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.0-375}"
            },
            "x": {
              "$type": "number",
              "$value": "{scale.0-5}"
            }
          }
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{colours.interaction-states.hover.background-subtle-hover}"
          },
          "color": {
            "$type": "color",
            "$value": "{content.hover.color}"
          }
        },
        "selected": {
          "background": {
            "$type": "color",
            "$value": "{highlight.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{highlight.color}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{datatable.border.color}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": -1
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{datatable.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        }
      }
    },
    "row": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.hover.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{highlight.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{highlight.color}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": -1
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      },
      "toggle": {
        "button": {
          "color": {
            "$type": "color",
            "$value": "{text.muted.color}"
          },
          "size": {
            "$type": "number",
            "$value": "{scale.1-75}"
          },
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{content.hover.background}"
            },
            "color": {
              "$type": "color",
              "$value": "{text.color}"
            }
          },
          "selected": {
            "hover": {
              "background": {
                "$type": "color",
                "$value": "{content.background}"
              },
              "color": {
                "$type": "color",
                "$value": "{primary.color}"
              }
            }
          },
          "border": {
            "radius": {
              "$type": "number",
              "$value": 12.25
            }
          },
          "focus": {
            "ring": {
              "width": {
                "$type": "number",
                "$value": "{focus.ring.width}"
              },
              "offset": {
                "$type": "number",
                "$value": "{focus.ring.offset}"
              },
              "color": {
                "$type": "color",
                "$value": "{focus.ring.color}"
              }
            }
          }
        }
      }
    },
    "body": {
      "cell": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{datatable.border.color}"
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        },
        "sm": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.0-375}"
            },
            "x": {
              "$type": "number",
              "$value": "{scale.0-5}"
            }
          }
        },
        "lg": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.1}"
            },
            "x": {
              "$type": "number",
              "$value": "{scale.1-25}"
            }
          }
        }
      }
    },
    "footer": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "lg": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.1}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1-25}"
          }
        }
      },
      "sm": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-375}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-5}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "cell": {
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{datatable.border.color}"
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        },
        "sm": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.0-375}"
            },
            "x": {
              "$type": "number",
              "$value": "{scale.0-5}"
            }
          }
        },
        "lg": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.1}"
            },
            "x": {
              "$type": "number",
              "$value": "{scale.1-25}"
            }
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{datatable.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        }
      }
    },
    "drop": {
      "point": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    },
    "column": {
      "title": {
        "font": {
          "weight": {
            "$type": "number",
            "$value": 600
          }
        }
      },
      "footer": {
        "font": {
          "weight": {
            "$type": "number",
            "$value": 600
          }
        }
      },
      "resizer": {
        "width": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      }
    },
    "resize": {
      "indicator": {
        "width": {
          "$type": "number",
          "$value": 1
        },
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    },
    "sort": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        },
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.hover.color}"
          }
        }
      }
    },
    "loading": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    },
    "filter": {
      "inline": {
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "overlay": {
        "select": {
          "background": {
            "$type": "color",
            "$value": "{overlay.select.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{overlay.select.color}"
          },
          "border": {
            "color": {
              "$type": "color",
              "$value": "{overlay.select.border.color}"
            },
            "radius": {
              "$type": "number",
              "$value": "{overlay.select.border.radius}"
            }
          }
        },
        "popover": {
          "background": {
            "$type": "color",
            "$value": "{overlay.popover.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{overlay.popover.color}"
          },
          "padding": {
            "$type": "number",
            "$value": "{overlay.popover.padding}"
          },
          "gap": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "border": {
            "color": {
              "$type": "color",
              "$value": "{overlay.popover.border.color}"
            },
            "radius": {
              "$type": "number",
              "$value": "{overlay.popover.border.radius}"
            }
          }
        }
      },
      "rule": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          }
        }
      },
      "constraint": {
        "color": {
          "$type": "color",
          "$value": "{list.option.color}"
        },
        "list": {
          "gap": {
            "$type": "number",
            "$value": "{list.gap}"
          }
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.focus.color}"
          }
        },
        "selected": {
          "background": {
            "$type": "color",
            "$value": "{list.option.selected.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.selected.color}"
          },
          "focus": {
            "background": {
              "$type": "color",
              "$value": "{list.option.selected.focus.background}"
            },
            "color": {
              "$type": "color",
              "$value": "{list.option.selected.focus.color}"
            }
          }
        },
        "separator": {
          "border": {
            "color": {
              "$type": "color",
              "$value": "{content.border.color}"
            }
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{list.option.border.radius}"
          }
        }
      }
    },
    "paginator": {
      "top": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{datatable.border.color}"
          },
          "width": {
            "$type": "number",
            "$value": 1
          }
        }
      },
      "bottom": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{datatable.border.color}"
          },
          "width": {
            "$type": "number",
            "$value": 1
          }
        }
      }
    }
  },
  "dataview": {
    "padding": {
      "$type": "number",
      "$value": 0
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.0000)"
      },
      "width": {
        "$type": "number",
        "$value": 0
      },
      "radius": {
        "$type": "number",
        "$value": 0
      }
    },
    "header": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        },
        "radius": {
          "$type": "number",
          "$value": 0
        }
      }
    },
    "content": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "$type": "number",
        "$value": 0
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "radius": {
          "$type": "number",
          "$value": 0
        },
        "width": {
          "$type": "number",
          "$value": 0
        }
      }
    },
    "footer": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        },
        "radius": {
          "$type": "number",
          "$value": 0
        }
      }
    },
    "paginator": {
      "top": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          },
          "width": {
            "$type": "number",
            "$value": 1
          }
        }
      },
      "bottom": {
        "border": {
          "width": {
            "$type": "number",
            "$value": 1
          },
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          }
        }
      }
    }
  },
  "dialog": {
    "background": {
      "$type": "color",
      "$value": "{overlay.modal.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{overlay.modal.color}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{overlay.modal.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{overlay.modal.border.radius}"
      }
    },
    "header": {
      "padding": {
        "$type": "number",
        "$value": "{overlay.modal.padding}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "title": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-25}"
        },
        "weight": {
          "$type": "number",
          "$value": 600
        }
      }
    },
    "footer": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        },
        "left": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        }
      }
    },
    "content": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        },
        "left": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        }
      }
    }
  },
  "divider": {
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      }
    },
    "content": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      }
    },
    "horizontal": {
      "padding": {
        "$type": "number",
        "$value": 0
      },
      "margin": {
        "y": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "x": {
          "$type": "number",
          "$value": 0
        }
      },
      "content": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": 0
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-5}"
          }
        }
      }
    },
    "vertical": {
      "padding": {
        "$type": "number",
        "$value": 0
      },
      "margin": {
        "y": {
          "$type": "number",
          "$value": 0
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "content": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "x": {
            "$type": "number",
            "$value": 0
          }
        }
      }
    }
  },
  "dock": {
    "background": {
      "$type": "color",
      "$value": "rgba(255, 255, 255, 0.1000)"
    },
    "padding": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.2000)"
      },
      "radius": {
        "$type": "number",
        "$value": "{border.radius.xl}"
      }
    },
    "item": {
      "padding": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "size": {
        "$type": "number",
        "$value": "{scale.3}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    }
  },
  "drawer": {
    "background": {
      "$type": "color",
      "$value": "{overlay.modal.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{overlay.modal.color}"
    },
    "content": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        },
        "left": {
          "$type": "number",
          "$value": "{overlay.modal.padding}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{overlay.modal.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{overlay.modal.border.radius}"
      }
    },
    "header": {
      "padding": {
        "$type": "number",
        "$value": "{overlay.modal.padding}"
      }
    },
    "footer": {
      "padding": {
        "$type": "number",
        "$value": "{overlay.modal.padding}"
      }
    },
    "title": {
      "font": {
        "weight": {
          "$type": "number",
          "$value": 600
        },
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      }
    }
  },
  "editor": {
    "toolbar": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "item": {
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        }
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.select.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.select.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.select.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.select.border.radius}"
        }
      },
      "option": {
        "color": {
          "$type": "color",
          "$value": "{list.option.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.focus.color}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{list.option.border.radius}"
          }
        }
      }
    },
    "content": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    }
  },
  "fieldset": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "padding": {
      "top": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "right": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "bottom": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "left": {
        "$type": "number",
        "$value": "{scale.1-125}"
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "legend": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.hover.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        },
        "color": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        }
      },
      "font": {
        "weight": {
          "$type": "number",
          "$value": 600
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      }
    },
    "toggle": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.hover.muted.color}"
          }
        }
      }
    },
    "content": {
      "padding": {
        "$type": "number",
        "$value": 0
      }
    }
  },
  "fileupload": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "header": {
      "background": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.0000)"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "border": {
        "width": {
          "$type": "number",
          "$value": 0
        },
        "radius": {
          "$type": "number",
          "$value": 0
        },
        "color": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        }
      }
    },
    "file": {
      "padding": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      },
      "info": {
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "list": {
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      }
    },
    "progressbar": {
      "height": {
        "$type": "number",
        "$value": "{scale.0-25}"
      }
    },
    "basic": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "content": {
      "gap": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "left": {
          "$type": "number",
          "$value": "{scale.1-125}"
        }
      },
      "highlight": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        }
      }
    }
  },
  "floatlabel": {
    "color": {
      "$type": "color",
      "$value": "{form.field.float.label.color}"
    },
    "focus": {
      "color": {
        "$type": "color",
        "$value": "{form.field.float.label.focus.color}"
      }
    },
    "active": {
      "color": {
        "$type": "color",
        "$value": "{form.field.float.label.active.color}"
      },
      "font": {
        "weight": {
          "$type": "number",
          "$value": 400
        },
        "size": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      }
    },
    "position": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "font": {
      "weight": {
        "$type": "number",
        "$value": 500
      }
    },
    "over": {
      "active": {
        "top": {
          "$type": "number",
          "$value": "{scale.neg-1-25}"
        }
      }
    },
    "on": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.xs}"
        }
      },
      "active": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": 0
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-125}"
          }
        },
        "background": {
          "$type": "color",
          "$value": "{form.field.background}"
        }
      }
    },
    "in": {
      "input": {
        "padding": {
          "top": {
            "$type": "number",
            "$value": "{scale.1-5}"
          },
          "bottom": {
            "$type": "number",
            "$value": "{form.field.padding.y}"
          }
        }
      },
      "active": {
        "top": {
          "$type": "number",
          "$value": "{form.field.padding.y}"
        }
      }
    },
    "invalid": {
      "color": {
        "$type": "color",
        "$value": "{form.field.float.label.invalid.color}"
      }
    }
  },
  "galleria": {
    "thumbnail": {
      "nav": {
        "button": {
          "size": {
            "$type": "number",
            "$value": "{scale.2}"
          },
          "gutter": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{content.border.radius}"
            }
          },
          "focus": {
            "ring": {
              "width": {
                "$type": "number",
                "$value": "{focus.ring.width}"
              },
              "color": {
                "$type": "color",
                "$value": "{focus.ring.color}"
              },
              "offset": {
                "$type": "number",
                "$value": "{focus.ring.offset}"
              }
            }
          },
          "icon": {
            "size": {
              "$type": "number",
              "$value": "{scale.1}"
            }
          }
        }
      }
    },
    "indicator": {
      "button": {
        "width": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "height": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": 7
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      },
      "list": {
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "padding": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "border": {
      "width": {
        "$type": "number",
        "$value": 1
      },
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "nav": {
      "button": {
        "background": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.1000)"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.100}"
        },
        "size": {
          "$type": "number",
          "$value": "{scale.3}"
        },
        "gutter": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "rgba(255, 255, 255, 0.2000)"
          },
          "color": {
            "$type": "color",
            "$value": "{surface.0}"
          }
        },
        "prev": {
          "border": {
            "radius": {
              "$type": "number",
              "$value": 21
            }
          }
        },
        "next": {
          "border": {
            "radius": {
              "$type": "number",
              "$value": 21
            }
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            }
          }
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      }
    },
    "thumbnails": {
      "content": {
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.1}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-25}"
          }
        }
      }
    },
    "caption": {
      "background": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.5000)"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "inset": {
      "indicator": {
        "list": {
          "background": {
            "$type": "color",
            "$value": "rgba(0, 0, 0, 0.5000)"
          }
        },
        "button": {
          "background": {
            "$type": "color",
            "$value": "rgba(255, 255, 255, 0.4000)"
          },
          "hover": {
            "background": {
              "$type": "color",
              "$value": "rgba(255, 255, 255, 0.6000)"
            }
          },
          "active": {
            "background": {
              "$type": "color",
              "$value": "rgba(255, 255, 255, 0.9000)"
            }
          }
        }
      }
    },
    "close": {
      "button": {
        "size": {
          "$type": "number",
          "$value": "{scale.3}"
        },
        "gutter": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "background": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.1000)"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.50}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "rgba(255, 255, 255, 0.2000)"
          },
          "color": {
            "$type": "color",
            "$value": "{surface.0}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": 21
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        },
        "icon": {
          "size": {
            "$type": "number",
            "$value": "{scale.1-5}"
          }
        }
      }
    }
  },
  "iconfield": {
    "icon": {
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      }
    },
    "figma": {
      "sm": {
        "icon": {
          "size": {
            "$type": "number",
            "$value": "{inputtext.sm.font.size}"
          }
        }
      },
      "lg": {
        "icon": {
          "size": {
            "$type": "number",
            "$value": "{inputtext.lg.font.size}"
          }
        }
      }
    }
  },
  "iftalabel": {
    "top": {
      "$type": "number",
      "$value": "{form.field.padding.y}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.float.label.color}"
    },
    "input": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": "{scale.1-5}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{form.field.padding.y}"
        }
      }
    },
    "invalid": {
      "color": {
        "$type": "color",
        "$value": "{form.field.float.label.invalid.color}"
      }
    },
    "font": {
      "weight": {
        "$type": "number",
        "$value": 400
      },
      "size": {
        "$type": "number",
        "$value": "{scale.0-75}"
      }
    },
    "focus": {
      "color": {
        "$type": "color",
        "$value": "{form.field.float.label.focus.color}"
      }
    },
    "position": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      }
    }
  },
  "image": {
    "preview": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      },
      "mask": {
        "background": {
          "$type": "color",
          "$value": "{mask.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{mask.color}"
        }
      }
    },
    "toolbar": {
      "background": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.1000)"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "blur": {
        "$type": "number",
        "$value": 8
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.2000)"
        },
        "width": {
          "$type": "number",
          "$value": 1
        },
        "radius": {
          "$type": "number",
          "$value": 30
        }
      },
      "position": {
        "right": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "top": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "action": {
      "color": {
        "$type": "color",
        "$value": "{surface.50}"
      },
      "size": {
        "$type": "number",
        "$value": "{scale.3}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.1000)"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.0}"
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-5}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": 21
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    }
  },
  "imagecompare": {
    "handle": {
      "size": {
        "$type": "number",
        "$value": 15
      },
      "background": {
        "$type": "color",
        "$value": "rgba(255, 255, 255, 0.3000)"
      },
      "hover": {
        "size": {
          "$type": "number",
          "$value": 30
        },
        "background": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.3000)"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "rgba(0, 0, 0, 0.0000)"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "width": {
          "$type": "number",
          "$value": 0
        },
        "radius": {
          "$type": "number",
          "$value": 7.5
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "rgba(255, 255, 255, 0.3000)"
          }
        }
      }
    }
  },
  "inputgroup": {
    "addon": {
      "background": {
        "$type": "color",
        "$value": "{form.field.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{form.field.border.radius}"
        }
      },
      "min": {
        "width": {
          "$type": "number",
          "$value": "{scale.2-5}"
        }
      }
    }
  },
  "inputnumber": {
    "button": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{form.field.border.radius}"
        }
      },
      "vertical": {
        "padding": {
          "$type": "number",
          "$value": "{form.field.padding.y}"
        }
      }
    }
  },
  "inputotp": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "input": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "sm": {
        "width": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      },
      "lg": {
        "width": {
          "$type": "number",
          "$value": "{scale.3}"
        }
      }
    }
  },
  "inputtext": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        }
      }
    },
    "invalid": {
      "border": {
        "width": {
          "$type": "number",
          "$value": "{strokes.2}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "sm": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      }
    },
    "lg": {
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.lg.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.lg.padding.y}"
        }
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-125}"
        }
      }
    }
  },
  "inplace": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "focus": {
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        }
      }
    },
    "display": {
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.hover.color}"
        }
      }
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      },
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      }
    }
  },
  "knob": {
    "focus": {
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        }
      }
    },
    "value": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      }
    },
    "range": {
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      }
    },
    "text": {
      "color": {
        "$type": "color",
        "$value": "{text.muted.color}"
      }
    }
  },
  "listbox": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "list": {
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.padding.x}"
        }
      },
      "header": {
        "padding": {
          "top": {
            "$type": "number",
            "$value": "{list.header.padding.top}"
          },
          "right": {
            "$type": "number",
            "$value": "{list.header.padding.right}"
          },
          "bottom": {
            "$type": "number",
            "$value": "{list.header.padding.bottom}"
          },
          "left": {
            "$type": "number",
            "$value": "{list.header.padding.left}"
          }
        }
      },
      "gap": {
        "$type": "number",
        "$value": "{list.gap}"
      }
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      }
    },
    "option": {
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{list.option.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.focus.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{list.option.selected.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.selected.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.selected.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.selected.focus.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{list.option.border.radius}"
        }
      },
      "group": {
        "background": {
          "$type": "color",
          "$value": "{list.option.group.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.group.color}"
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": "{list.option.group.font.weight}"
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{list.option.group.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{list.option.group.padding.x}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.option.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.option.padding.x}"
        }
      }
    },
    "checkmark": {
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "gutter": {
        "start": {
          "$type": "number",
          "$value": "{scale.neg-0-375}"
        },
        "end": {
          "$type": "number",
          "$value": "{scale.0-375}"
        }
      }
    }
  },
  "megamenu": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "base": {
      "item": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{navigation.item.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{navigation.item.padding.x}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{content.border.radius}"
          }
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "vertical": {
      "orientation": {
        "gap": {
          "$type": "number",
          "$value": "{navigation.list.gap}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{navigation.list.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{navigation.list.padding.x}"
          }
        }
      }
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{navigation.item.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.item.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.item.padding.x}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.focus.color}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.active.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.active.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{navigation.item.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.active.color}"
          }
        }
      }
    },
    "overlay": {
      "padding": {
        "$type": "number",
        "$value": 0
      },
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    },
    "separator": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    },
    "mobile": {
      "button": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-75}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.hover.muted.color}"
          },
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      }
    },
    "submenu": {
      "gap": {
        "$type": "number",
        "$value": "{navigation.list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.list.padding.x}"
        }
      },
      "label": {
        "background": {
          "$type": "color",
          "$value": "{navigation.submenu.label.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.label.color}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{navigation.submenu.label.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{navigation.submenu.label.padding.x}"
          }
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": "{navigation.submenu.label.font.weight}"
          }
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{navigation.submenu.icon.size}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.active.color}"
          }
        }
      }
    },
    "horizontal": {
      "orientation": {
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-5}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-75}"
          }
        }
      }
    }
  },
  "menu": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{navigation.list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.list.padding.x}"
        }
      }
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{navigation.item.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.item.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.item.padding.x}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.focus.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{navigation.item.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        }
      }
    },
    "submenu": {
      "label": {
        "background": {
          "$type": "color",
          "$value": "{navigation.submenu.label.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.label.color}"
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": "{navigation.submenu.label.font.weight}"
          }
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{navigation.submenu.label.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{navigation.submenu.label.padding.x}"
          }
        }
      }
    },
    "separator": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    }
  },
  "menubar": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "base": {
      "item": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{navigation.item.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{navigation.item.padding.x}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{content.border.radius}"
          }
        }
      }
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "x": {
        "$type": "number",
        "$value": "{scale.0-75}"
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{navigation.item.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.item.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.item.padding.x}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.focus.color}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.active.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.active.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{navigation.item.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.active.color}"
          }
        }
      }
    },
    "submenu": {
      "gap": {
        "$type": "number",
        "$value": "{navigation.list.gap}"
      },
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.list.padding.x}"
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "mobile": {
        "indent": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{navigation.submenu.icon.size}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.active.color}"
          }
        }
      }
    },
    "separator": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    },
    "mobile": {
      "button": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-75}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.hover.muted.color}"
          },
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      }
    }
  },
  "message": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{radius.medium}"
      },
      "width": {
        "$type": "number",
        "$value": 0
      }
    },
    "content": {
      "gap": {
        "$type": "number",
        "$value": "{spacing.component.5}"
      },
      "lg": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{spacing.component.4}"
          },
          "x": {
            "$type": "number",
            "$value": "{spacing.component.6}"
          }
        }
      },
      "sm": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{spacing.component.2}"
          },
          "x": {
            "$type": "number",
            "$value": "{spacing.component.4}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{spacing.component.4}"
        },
        "x": {
          "$type": "number",
          "$value": "{spacing.component.6}"
        }
      }
    },
    "text": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "weight": {
          "$type": "number",
          "$value": 500
        }
      },
      "sm": {
        "font": {
          "size": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        }
      },
      "lg": {
        "font": {
          "size": {
            "$type": "number",
            "$value": "{scale.1-125}"
          }
        }
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "sm": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "lg": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-25}"
        }
      }
    },
    "close": {
      "button": {
        "width": {
          "$type": "number",
          "$value": "{scale.1-75}"
        },
        "height": {
          "$type": "number",
          "$value": "{scale.1-75}"
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            }
          }
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "sm": {
          "size": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        },
        "lg": {
          "size": {
            "$type": "number",
            "$value": "{scale.1-125}"
          }
        }
      }
    },
    "outlined": {
      "border": {
        "width": {
          "$type": "number",
          "$value": 1
        }
      }
    },
    "simple": {
      "content": {
        "padding": {
          "$type": "number",
          "$value": 0
        }
      }
    }
  },
  "metergroup": {
    "gap": {
      "$type": "number",
      "$value": "{scale.1}"
    },
    "meters": {
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "size": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "label": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "marker": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "list": {
        "vertical": {
          "gap": {
            "$type": "number",
            "$value": "{scale.0-5}"
          }
        },
        "horizontal": {
          "gap": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        }
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    }
  },
  "multiselect": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "option": {
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.option.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.option.padding.x}"
        }
      },
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{list.option.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.focus.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{list.option.selected.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.selected.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.selected.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.selected.focus.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{list.option.border.radius}"
        }
      },
      "group": {
        "background": {
          "$type": "color",
          "$value": "{list.option.group.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.group.color}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{list.option.group.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{list.option.group.padding.x}"
          }
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": "{list.option.group.font.weight}"
          }
        }
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "dropdown": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.select.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.select.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.select.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.select.border.radius}"
        }
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.padding.x}"
        }
      },
      "header": {
        "padding": {
          "top": {
            "$type": "number",
            "$value": "{list.header.padding.top}"
          },
          "right": {
            "$type": "number",
            "$value": "{list.header.padding.right}"
          },
          "bottom": {
            "$type": "number",
            "$value": "{list.header.padding.bottom}"
          },
          "left": {
            "$type": "number",
            "$value": "{list.header.padding.left}"
          }
        }
      }
    },
    "chip": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.sm}"
        }
      }
    },
    "sm": {
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      }
    },
    "lg": {
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.lg.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.lg.padding.y}"
        }
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      }
    },
    "clear": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{form.field.icon.color}"
        }
      }
    }
  },
  "orderlist": {
    "gap": {
      "$type": "number",
      "$value": "{scale.1-125}"
    },
    "controls": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    }
  },
  "organizationchart": {
    "gutter": {
      "$type": "number",
      "$value": "{scale.0-75}"
    },
    "node": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "toggleable": {
        "padding": {
          "top": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "right": {
            "$type": "number",
            "$value": "{scale.1}"
          },
          "bottom": {
            "$type": "number",
            "$value": "{scale.1-25}"
          },
          "left": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.hover.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{highlight.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{highlight.color}"
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "toggle": {
        "button": {
          "background": {
            "$type": "color",
            "$value": "{content.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{text.muted.color}"
          },
          "size": {
            "$type": "number",
            "$value": "{scale.1-5}"
          },
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{content.hover.background}"
            },
            "color": {
              "$type": "color",
              "$value": "{text.color}"
            }
          },
          "border": {
            "color": {
              "$type": "color",
              "$value": "{content.border.color}"
            },
            "radius": {
              "$type": "number",
              "$value": "{scale.0-75}"
            }
          },
          "focus": {
            "ring": {
              "width": {
                "$type": "number",
                "$value": "{focus.ring.width}"
              },
              "offset": {
                "$type": "number",
                "$value": "{focus.ring.offset}"
              },
              "color": {
                "$type": "color",
                "$value": "{focus.ring.color}"
              }
            }
          }
        }
      }
    },
    "connector": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "height": {
        "$type": "number",
        "$value": 24
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    }
  },
  "overlaybadge": {
    "outline": {
      "color": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "width": {
        "$type": "number",
        "$value": 2
      }
    }
  },
  "paginator": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-25}"
    },
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "x": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "nav": {
      "button": {
        "background": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "width": {
          "$type": "number",
          "$value": "{scale.2-5}"
        },
        "height": {
          "$type": "number",
          "$value": "{scale.2-5}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{text.color}"
          }
        },
        "selected": {
          "background": {
            "$type": "color",
            "$value": "{highlight.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{highlight.color}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{scale.1-25}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      }
    },
    "current": {
      "page": {
        "report": {
          "color": {
            "$type": "color",
            "$value": "{text.muted.color}"
          }
        }
      }
    },
    "jump": {
      "to": {
        "page": {
          "input": {
            "max": {
              "width": {
                "$type": "number",
                "$value": "{scale.2-5}"
              }
            }
          }
        }
      }
    }
  },
  "panel": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "toggleable": {
      "header": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-375}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1-125}"
          }
        }
      }
    },
    "footer": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "left": {
          "$type": "number",
          "$value": "{scale.1-125}"
        }
      }
    },
    "content": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "left": {
          "$type": "number",
          "$value": "{scale.1-125}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "header": {
      "background": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.0000)"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "padding": {
        "$type": "number",
        "$value": "{scale.1-125}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": 0
        },
        "width": {
          "top": {
            "$type": "number",
            "$value": 0
          },
          "right": {
            "$type": "number",
            "$value": 0
          },
          "bottom": {
            "$type": "number",
            "$value": 0
          },
          "left": {
            "$type": "number",
            "$value": 0
          }
        }
      }
    },
    "title": {
      "font": {
        "weight": {
          "$type": "number",
          "$value": 600
        }
      }
    }
  },
  "panelmenu": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "panel": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-25}"
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        },
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "first": {
        "border": {
          "width": {
            "$type": "number",
            "$value": 1
          }
        },
        "top": {
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{content.border.radius}"
            }
          }
        }
      },
      "last": {
        "border": {
          "width": {
            "$type": "number",
            "$value": 1
          }
        },
        "bottom": {
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{content.border.radius}"
            }
          }
        }
      }
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.item.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.item.padding.x}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.focus.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        }
      }
    },
    "submenu": {
      "indent": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.focus.color}"
          }
        }
      }
    }
  },
  "password": {
    "meter": {
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.0-75}"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    },
    "icon": {
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.popover.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.popover.color}"
      },
      "padding": {
        "$type": "number",
        "$value": "{overlay.popover.padding}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.popover.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.popover.border.radius}"
        }
      }
    },
    "content": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    }
  },
  "picklist": {
    "gap": {
      "$type": "number",
      "$value": "{scale.1-125}"
    },
    "controls": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    }
  },
  "popover": {
    "background": {
      "$type": "color",
      "$value": "{overlay.popover.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{overlay.popover.color}"
    },
    "gutter": {
      "$type": "number",
      "$value": 10
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{overlay.popover.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{radius.medium}"
      }
    },
    "arrow": {
      "offset": {
        "$type": "number",
        "$value": "{scale.1-25}"
      }
    },
    "content": {
      "padding": {
        "$type": "number",
        "$value": "{overlay.popover.padding}"
      }
    }
  },
  "progressbar": {
    "background": {
      "$type": "color",
      "$value": "{content.border.color}"
    },
    "height": {
      "$type": "number",
      "$value": "{scale.1-25}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "value": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      }
    },
    "label": {
      "color": {
        "$type": "color",
        "$value": "{primary.contrast.color}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "weight": {
          "$type": "number",
          "$value": 600
        }
      }
    }
  },
  "radiobutton": {
    "width": {
      "$type": "number",
      "$value": "{scale.1-25}"
    },
    "height": {
      "$type": "number",
      "$value": "{scale.1-25}"
    },
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "checked": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{primary.hover.color}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.hover.color}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "focus": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        }
      },
      "disabled": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.0-75}"
      },
      "checked": {
        "color": {
          "$type": "color",
          "$value": "{primary.contrast.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{primary.contrast.color}"
          }
        }
      },
      "disabled": {
        "color": {
          "$type": "color",
          "$value": "{form.field.disabled.color}"
        }
      },
      "sm": {
        "size": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "lg": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "sm": {
      "width": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "lg": {
      "width": {
        "$type": "number",
        "$value": "{scale.1-5}"
      },
      "height": {
        "$type": "number",
        "$value": "{scale.1-5}"
      }
    }
  },
  "rating": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-25}"
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.muted.color}"
      },
      "hover": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "active": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    },
    "focus": {
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        }
      }
    }
  },
  "scrollpanel": {
    "bar": {
      "size": {
        "$type": "number",
        "$value": 9
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.sm}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    }
  },
  "select": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": "{strokes.2}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "dropdown": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.select.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.select.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.select.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.select.border.radius}"
        }
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.padding.x}"
        }
      },
      "header": {
        "padding": {
          "top": {
            "$type": "number",
            "$value": "{list.header.padding.top}"
          },
          "right": {
            "$type": "number",
            "$value": "{list.header.padding.right}"
          },
          "bottom": {
            "$type": "number",
            "$value": "{list.header.padding.bottom}"
          },
          "left": {
            "$type": "number",
            "$value": "{list.header.padding.left}"
          }
        }
      }
    },
    "option": {
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "group": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{list.option.group.padding.y}"
          },
          "x": {
            "$type": "number",
            "$value": "{list.option.group.padding.x}"
          }
        },
        "background": {
          "$type": "color",
          "$value": "{list.option.group.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.group.color}"
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": "{list.option.group.font.weight}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{list.option.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{list.option.padding.x}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{list.option.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.focus.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{list.option.selected.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{list.option.selected.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{list.option.selected.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{list.option.selected.focus.color}"
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{list.option.border.radius}"
        }
      }
    },
    "clear": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{form.field.icon.color}"
        }
      }
    },
    "checkmark": {
      "color": {
        "$type": "color",
        "$value": "{list.option.color}"
      },
      "gutter": {
        "start": {
          "$type": "number",
          "$value": "{scale.neg-0-375}"
        },
        "end": {
          "$type": "number",
          "$value": "{scale.0-375}"
        }
      }
    },
    "sm": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      }
    },
    "lg": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.lg.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.lg.padding.y}"
        }
      }
    }
  },
  "selectbutton": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    }
  },
  "skeleton": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    }
  },
  "slider": {
    "track": {
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "size": {
        "$type": "number",
        "$value": 3
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    },
    "range": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      }
    },
    "handle": {
      "width": {
        "$type": "number",
        "$value": 20
      },
      "height": {
        "$type": "number",
        "$value": 20
      },
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "content": {
        "width": {
          "$type": "number",
          "$value": 16
        },
        "height": {
          "$type": "number",
          "$value": 16
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{content.background}"
          }
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": 8
          }
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": 10
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    }
  },
  "speeddial": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    }
  },
  "splitbutton": {
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "rounded": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    }
  },
  "splitter": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      }
    },
    "gutter": {
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      }
    },
    "handle": {
      "size": {
        "$type": "number",
        "$value": 24
      },
      "background": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.0000)"
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          }
        }
      }
    }
  },
  "stepper": {
    "separator": {
      "background": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "size": {
        "$type": "number",
        "$value": 2
      },
      "margin": {
        "top": {
          "$type": "number",
          "$value": 0
        },
        "right": {
          "$type": "number",
          "$value": 0
        },
        "bottom": {
          "$type": "number",
          "$value": 0
        },
        "left": {
          "$type": "number",
          "$value": "{scale.1-625}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{colours.basic.stroke-subtle}"
        }
      }
    },
    "step": {
      "padding": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.1}"
      },
      "header": {
        "padding": {
          "$type": "number",
          "$value": 0
        },
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{content.border.radius}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            }
          }
        }
      },
      "title": {
        "color": {
          "$type": "color",
          "$value": "{colours.basic.text}"
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{colours.basic.text}"
          }
        },
        "font": {
          "weight": {
            "$type": "number",
            "$value": 500
          }
        }
      },
      "number": {
        "background": {
          "$type": "color",
          "$value": "{colours.basic.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{colours.basic.text}"
        },
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{colours.basic.accent-secondary}"
          },
          "color": {
            "$type": "color",
            "$value": "{colours.basic.text-on-accent}"
          },
          "border": {
            "color": {
              "$type": "color",
              "$value": "{colours.basic.accent-secondary}"
            }
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.basic.stroke}"
          },
          "radius": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        },
        "font": {
          "size": {
            "$type": "number",
            "$value": "{scale.1-143}"
          },
          "weight": {
            "$type": "number",
            "$value": 500
          }
        }
      }
    },
    "steppanel": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "$type": "number",
        "$value": 0
      }
    },
    "steppanels": {
      "padding": {
        "top": {
          "$type": "number",
          "$value": "{scale.0-875}"
        },
        "right": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "left": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      }
    }
  },
  "tabs": {
    "tablist": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        }
      }
    },
    "tab": {
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "background": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.0000)"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.1}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1-125}"
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        }
      },
      "hover": {
        "color": {
          "$type": "color",
          "$value": "{primary.hover.color}"
        },
        "background": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          }
        }
      },
      "active": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        },
        "background": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        }
      },
      "font": {
        "weight": {
          "$type": "number",
          "$value": 600
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": -1
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    },
    "tabpanel": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "top": {
          "$type": "number",
          "$value": "{scale.0-875}"
        },
        "right": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "bottom": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "left": {
          "$type": "number",
          "$value": "{scale.1-125}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": "{focus.ring.offset}"
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    },
    "nav": {
      "button": {
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "width": {
          "$type": "number",
          "$value": "{scale.2-5}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.color}"
          }
        },
        "focus": {
          "ring": {
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            },
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": -1
            }
          }
        }
      }
    },
    "active": {
      "bar": {
        "height": {
          "$type": "number",
          "$value": 1
        },
        "bottom": {
          "$type": "number",
          "$value": -1
        },
        "background": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    }
  },
  "tag": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-25}"
    },
    "font": {
      "size": {
        "$type": "number",
        "$value": "{scale.0-875}"
      },
      "weight": {
        "$type": "number",
        "$value": 700
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "rounded": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.xl}"
        }
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.0-75}"
      }
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "x": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    }
  },
  "terminal": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "height": {
      "$type": "number",
      "$value": "{scale.18}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "prompt": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-25}"
      }
    },
    "command": {
      "response": {
        "margin": {
          "y": {
            "$type": "number",
            "$value": 2
          },
          "x": {
            "$type": "number",
            "$value": 0
          }
        }
      }
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      },
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      }
    }
  },
  "textarea": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "sm": {
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      }
    },
    "lg": {
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.lg.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.lg.padding.y}"
        }
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      }
    }
  },
  "tieredmenu": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "list": {
      "gap": {
        "$type": "number",
        "$value": "{navigation.list.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.list.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.list.padding.x}"
        }
      }
    },
    "item": {
      "color": {
        "$type": "color",
        "$value": "{navigation.item.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{navigation.item.gap}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{navigation.item.padding.y}"
        },
        "x": {
          "$type": "number",
          "$value": "{navigation.item.padding.x}"
        }
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.focus.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.focus.color}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{navigation.item.active.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.item.active.color}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{navigation.item.border.radius}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{navigation.item.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.item.icon.active.color}"
          }
        }
      }
    },
    "submenu": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{navigation.submenu.icon.size}"
        },
        "color": {
          "$type": "color",
          "$value": "{navigation.submenu.icon.color}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.focus.color}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{navigation.submenu.icon.active.color}"
          }
        }
      },
      "mobile": {
        "indent": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "separator": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        }
      }
    }
  },
  "timeline": {
    "event": {
      "min": {
        "height": {
          "$type": "number",
          "$value": "{scale.5}"
        }
      },
      "marker": {
        "size": {
          "$type": "number",
          "$value": "{scale.1-125}"
        },
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": 7.875
          },
          "width": {
            "$type": "number",
            "$value": 2
          },
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          }
        },
        "content": {
          "size": {
            "$type": "number",
            "$value": "{scale.0-375}"
          },
          "background": {
            "$type": "color",
            "$value": "{primary.color}"
          },
          "border": {
            "radius": {
              "$type": "number",
              "$value": 2.625
            }
          }
        }
      },
      "connector": {
        "color": {
          "$type": "color",
          "$value": "{content.border.color}"
        },
        "size": {
          "$type": "number",
          "$value": 2
        }
      }
    },
    "vertical": {
      "event": {
        "content": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": 0
            },
            "x": {
              "$type": "number",
              "$value": "{scale.1}"
            }
          }
        }
      }
    },
    "horizontal": {
      "event": {
        "content": {
          "padding": {
            "y": {
              "$type": "number",
              "$value": "{scale.1}"
            },
            "x": {
              "$type": "number",
              "$value": 0
            }
          }
        }
      }
    }
  },
  "toast": {
    "width": {
      "$type": "number",
      "$value": "{scale.25}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      },
      "width": {
        "$type": "number",
        "$value": 1
      }
    },
    "icon": {
      "size": {
        "$type": "number",
        "$value": "{scale.1-125}"
      }
    },
    "content": {
      "padding": {
        "$type": "number",
        "$value": "{overlay.popover.padding}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    },
    "summary": {
      "font": {
        "weight": {
          "$type": "number",
          "$value": 500
        },
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "detail": {
      "font": {
        "weight": {
          "$type": "number",
          "$value": 500
        },
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        }
      }
    },
    "close": {
      "button": {
        "width": {
          "$type": "number",
          "$value": "{scale.1-75}"
        },
        "height": {
          "$type": "number",
          "$value": "{scale.1-75}"
        },
        "border": {
          "radius": {
            "$type": "number",
            "$value": "{scale.0-875}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": "{focus.ring.offset}"
            }
          }
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "text": {
      "gap": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    }
  },
  "togglebutton": {
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "padding": {
      "$type": "number",
      "$value": "{scale.0-25}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    },
    "icon": {
      "disabled": {
        "color": {
          "$type": "color",
          "$value": "{form.field.disabled.color}"
        }
      }
    },
    "font": {
      "weight": {
        "$type": "number",
        "$value": 500
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.disabled.background}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      }
    },
    "focus": {
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        }
      }
    },
    "content": {
      "left": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "top": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "lg": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-25}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-75}"
          }
        }
      },
      "sm": {
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-25}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.0-75}"
          }
        }
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      }
    },
    "rounded": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{radius.full}"
        }
      }
    },
    "sm": {
      "padding": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      },
      "zadding": {
        "x": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "y": {
          "$type": "number",
          "$value": "{scale.0-375}"
        }
      }
    },
    "lg": {
      "padding": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      },
      "zadding": {
        "x": {
          "$type": "number",
          "$value": "{scale.1-25}"
        },
        "y": {
          "$type": "number",
          "$value": "{scale.0-625}"
        }
      }
    }
  },
  "tree": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "padding": {
      "$type": "number",
      "$value": "{scale.1}"
    },
    "gap": {
      "$type": "number",
      "$value": 2
    },
    "indent": {
      "$type": "number",
      "$value": "{scale.1}"
    },
    "node": {
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "gap": {
        "$type": "number",
        "$value": "{scale.0-25}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{content.border.radius}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.hover.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{highlight.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{highlight.color}"
        }
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": -1
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.hover.muted.color}"
          }
        },
        "selected": {
          "color": {
            "$type": "color",
            "$value": "{highlight.color}"
          }
        }
      },
      "toggle": {
        "button": {
          "size": {
            "$type": "number",
            "$value": "{scale.1-75}"
          },
          "color": {
            "$type": "color",
            "$value": "{text.muted.color}"
          },
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{scale.0-875}"
            }
          },
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{content.hover.background}"
            },
            "color": {
              "$type": "color",
              "$value": "{text.hover.muted.color}"
            }
          },
          "selected": {
            "hover": {
              "background": {
                "$type": "color",
                "$value": "{content.background}"
              },
              "color": {
                "$type": "color",
                "$value": "{primary.color}"
              }
            }
          },
          "focus": {
            "ring": {
              "width": {
                "$type": "number",
                "$value": "{focus.ring.width}"
              },
              "offset": {
                "$type": "number",
                "$value": "{focus.ring.offset}"
              },
              "color": {
                "$type": "color",
                "$value": "{focus.ring.color}"
              }
            }
          }
        }
      }
    },
    "loading": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    },
    "filter": {
      "margin": {
        "$type": "number",
        "$value": "{scale.0-5}"
      }
    }
  },
  "treeselect": {
    "background": {
      "$type": "color",
      "$value": "{form.field.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{form.field.color}"
    },
    "tree": {
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-25}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.0-25}"
        }
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.disabled.color}"
      }
    },
    "filled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.filled.background}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.focus.background}"
        }
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{form.field.filled.hover.background}"
        }
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{form.field.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{form.field.border.radius}"
      }
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.hover.border.color}"
        }
      }
    },
    "focus": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.border.color}"
        }
      },
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{form.field.focus.ring.width}"
        },
        "offset": {
          "$type": "number",
          "$value": "{form.field.focus.ring.offset}"
        },
        "color": {
          "$type": "color",
          "$value": "{form.field.focus.ring.color}"
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.placeholder.color}"
        }
      }
    },
    "placeholder": {
      "color": {
        "$type": "color",
        "$value": "{form.field.placeholder.color}"
      }
    },
    "padding": {
      "x": {
        "$type": "number",
        "$value": "{form.field.padding.x}"
      },
      "y": {
        "$type": "number",
        "$value": "{form.field.padding.y}"
      }
    },
    "dropdown": {
      "width": {
        "$type": "number",
        "$value": "{scale.2-5}"
      },
      "color": {
        "$type": "color",
        "$value": "{form.field.icon.color}"
      }
    },
    "overlay": {
      "background": {
        "$type": "color",
        "$value": "{overlay.select.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{overlay.select.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{overlay.select.border.color}"
        },
        "radius": {
          "$type": "number",
          "$value": "{overlay.select.border.radius}"
        }
      }
    },
    "chip": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{border.radius.sm}"
        }
      }
    },
    "sm": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.sm.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.sm.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.sm.padding.y}"
        }
      }
    },
    "lg": {
      "font": {
        "size": {
          "$type": "number",
          "$value": "{form.field.lg.font.size}"
        }
      },
      "padding": {
        "x": {
          "$type": "number",
          "$value": "{form.field.lg.padding.x}"
        },
        "y": {
          "$type": "number",
          "$value": "{form.field.lg.padding.y}"
        }
      }
    },
    "clear": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{form.field.icon.color}"
        }
      }
    }
  },
  "toolbar": {
    "background": {
      "$type": "color",
      "$value": "{content.background}"
    },
    "color": {
      "$type": "color",
      "$value": "{content.color}"
    },
    "gap": {
      "$type": "number",
      "$value": "{scale.0-5}"
    },
    "padding": {
      "$type": "number",
      "$value": "{scale.0-75}"
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      },
      "radius": {
        "$type": "number",
        "$value": "{content.border.radius}"
      }
    }
  },
  "virtualscroller": {
    "loader": {
      "mask": {
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        }
      },
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    }
  },
  "toggleswitch": {
    "width": {
      "$type": "number",
      "$value": "{scale.2-5}"
    },
    "height": {
      "$type": "number",
      "$value": "{scale.1-5}"
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": 30
      },
      "width": {
        "$type": "number",
        "$value": 1
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      }
    },
    "gap": {
      "$type": "number",
      "$value": "{scale.0-25}"
    },
    "hover": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        }
      }
    },
    "checked": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        }
      },
      "hover": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "rgba(0, 0, 0, 0.0000)"
          }
        }
      }
    },
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      }
    },
    "handle": {
      "border": {
        "radius": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      },
      "size": {
        "$type": "number",
        "$value": "{scale.1}"
      }
    },
    "focus": {
      "ring": {
        "width": {
          "$type": "number",
          "$value": "{focus.ring.width}"
        },
        "color": {
          "$type": "color",
          "$value": "{focus.ring.color}"
        },
        "offset": {
          "$type": "number",
          "$value": "{focus.ring.offset}"
        }
      }
    }
  },
  "tooltip": {
    "max": {
      "width": {
        "$type": "number",
        "$value": "{scale.12-5}"
      }
    },
    "gutter": {
      "$type": "number",
      "$value": "{scale.0-25}"
    },
    "padding": {
      "y": {
        "$type": "number",
        "$value": "{scale.0-5}"
      },
      "x": {
        "$type": "number",
        "$value": "{scale.0-75}"
      }
    },
    "border": {
      "radius": {
        "$type": "number",
        "$value": "{overlay.popover.border.radius}"
      }
    }
  },
  "treetable": {
    "header": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{treetable.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        }
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      },
      "cell": {
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{content.hover.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{content.hover.color}"
          }
        },
        "selected": {
          "background": {
            "$type": "color",
            "$value": "{highlight.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{highlight.color}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{treetable.border.color}"
          }
        },
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        },
        "focus": {
          "ring": {
            "width": {
              "$type": "number",
              "$value": "{focus.ring.width}"
            },
            "offset": {
              "$type": "number",
              "$value": -1
            },
            "color": {
              "$type": "color",
              "$value": "{focus.ring.color}"
            }
          }
        }
      }
    },
    "column": {
      "title": {
        "font": {
          "weight": {
            "$type": "number",
            "$value": 600
          }
        }
      },
      "footer": {
        "font": {
          "weight": {
            "$type": "number",
            "$value": 600
          }
        }
      },
      "resizer": {
        "width": {
          "$type": "number",
          "$value": "{scale.0-5}"
        }
      }
    },
    "row": {
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{content.hover.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{content.hover.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{highlight.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{highlight.color}"
        }
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "focus": {
        "ring": {
          "width": {
            "$type": "number",
            "$value": "{focus.ring.width}"
          },
          "offset": {
            "$type": "number",
            "$value": -1
          },
          "color": {
            "$type": "color",
            "$value": "{focus.ring.color}"
          }
        }
      }
    },
    "body": {
      "cell": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{treetable.border.color}"
          }
        },
        "gap": {
          "$type": "number",
          "$value": "{scale.0-5}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        }
      }
    },
    "footer": {
      "cell": {
        "background": {
          "$type": "color",
          "$value": "{content.background}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{treetable.border.color}"
          }
        },
        "color": {
          "$type": "color",
          "$value": "{content.color}"
        },
        "padding": {
          "y": {
            "$type": "number",
            "$value": "{scale.0-75}"
          },
          "x": {
            "$type": "number",
            "$value": "{scale.1}"
          }
        }
      },
      "background": {
        "$type": "color",
        "$value": "{content.background}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{treetable.border.color}"
        },
        "width": {
          "$type": "number",
          "$value": 1
        }
      },
      "color": {
        "$type": "color",
        "$value": "{content.color}"
      },
      "padding": {
        "y": {
          "$type": "number",
          "$value": "{scale.0-75}"
        },
        "x": {
          "$type": "number",
          "$value": "{scale.1}"
        }
      }
    },
    "resize": {
      "indicator": {
        "width": {
          "$type": "number",
          "$value": 1
        },
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    },
    "sort": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        },
        "hover": {
          "color": {
            "$type": "color",
            "$value": "{text.hover.muted.color}"
          }
        },
        "size": {
          "$type": "number",
          "$value": "{scale.0-875}"
        }
      }
    },
    "loading": {
      "icon": {
        "size": {
          "$type": "number",
          "$value": "{scale.2}"
        }
      }
    },
    "node": {
      "toggle": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{content.hover.background}"
            },
            "color": {
              "$type": "color",
              "$value": "{text.color}"
            }
          },
          "selected": {
            "hover": {
              "background": {
                "$type": "color",
                "$value": "{content.background}"
              },
              "color": {
                "$type": "color",
                "$value": "{primary.color}"
              }
            }
          },
          "color": {
            "$type": "color",
            "$value": "{text.muted.color}"
          },
          "size": {
            "$type": "number",
            "$value": "{scale.1-75}"
          },
          "border": {
            "radius": {
              "$type": "number",
              "$value": "{scale.0-875}"
            }
          },
          "focus": {
            "ring": {
              "width": {
                "$type": "number",
                "$value": "{focus.ring.width}"
              },
              "offset": {
                "$type": "number",
                "$value": "{focus.ring.offset}"
              },
              "color": {
                "$type": "color",
                "$value": "{focus.ring.color}"
              }
            }
          }
        }
      }
    },
    "paginator": {
      "top": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          },
          "width": {
            "$type": "number",
            "$value": 1
          }
        }
      },
      "bottom": {
        "border": {
          "width": {
            "$type": "number",
            "$value": 1
          },
          "color": {
            "$type": "color",
            "$value": "{content.border.color}"
          }
        }
      }
    },
    "figma": {
      "body": {
        "cell": {
          "padding": {
            "sm": {
              "$type": "number",
              "$value": 5.25
            },
            "lg": {
              "$type": "number",
              "$value": 13.125
            }
          }
        }
      },
      "footer": {
        "cell": {
          "padding": {
            "sm": {
              "$type": "number",
              "$value": 5.25
            },
            "lg": {
              "$type": "number",
              "$value": 13.125
            }
          }
        },
        "padding": {
          "sm": {
            "$type": "number",
            "$value": 5.25
          },
          "lg": {
            "$type": "number",
            "$value": 13.125
          }
        }
      },
      "header": {
        "cell": {
          "padding": {
            "sm": {
              "$type": "number",
              "$value": 5.25
            },
            "lg": {
              "$type": "number",
              "$value": 13.125
            }
          }
        },
        "padding": {
          "sm": {
            "$type": "number",
            "$value": 5.25
          },
          "lg": {
            "$type": "number",
            "$value": 13.125
          }
        }
      }
    }
  }
}
